export const padadhikari = [
  {
    name: "Ashok Lohia (Charlie)",
    designation: "President",
    image: require("../assets/members/Ashok Lohiya.png"),
  },
  {
    name: "Chandra Prakash Panpaliya",
    designation: "Secretary",
    image: require("../assets/members/Chandra Prakash Panpaliya.png"),
  },
  {
    name: "Jayant Lohiya",
    designation: "Treasurer",
    image: require("../assets/members/Jayant B Lohiya.png"),
  },
  {
    name: "Pushpa Sharda",
    designation: "Vice President",
    image: require("../assets/members/Pushpa Sharda.png"),
  },
  {
    name: "Sandeep Heda",
    designation: "Vice President",
    image: require("../assets/members/Sandeep Hedda.png"),
  },
  {
    name: "Ashok Tapariya",
    designation: "Joint Secretary",
    image: require("../assets/members/Ashok Tapariya.png"),
  },
  {
    name: "Deepak Rathi",
    designation: "Joint Secretary",
    image: require("../assets/members/Deepak Rathi.png"),
  },
  {
    name: "Deepak Mundra",
    designation: "Organization Minister",
    image: require("../assets/members/Deepak Mundra.png"),
  },
];

export const karyakaarni = [
  {
    name: "Madhu Mundra",
    designation: "Kaaryakarni Member",
    image: require("../assets/members/Madhu Mundra.png"),
  },
  {
    name: "Sunita Heda",
    designation: "Kaaryakarni Member",
    image: require("../assets/members/Sunita Hedda.png"),
  },
  {
    name: "Ravi Boob",
    designation: "Kaaryakarni Member",
    image: require("../assets/members/Ravi Boob.png"),
  },
  {
    name: "Ajay Rathi",
    designation: "Kaaryakarni Member",
    image: require("../assets/members/Ajay Rathi.png"),
  },
  {
    name: "Mukesh Bhootra",
    designation: "Kaaryakarni Member",
    image: require("../assets/members/Mukesh Bhootra.png"),
  },
  {
    name: "Tejraj Mantri",
    designation: "Kaaryakarni Member",
    image: require("../assets/members/Tej Raj Mantri.png"),
  },
  {
    name: "Ravi Shah",
    designation: "Kaaryakarni Member",
    image: require("../assets/members/Ravi Shah.png"),
  },
  {
    name: "Abhishek Somani",
    designation: "Kaaryakarni Member",
    image: require("../assets/members/Abhishek Somani.png"),
  },
];

export const members = [
  {
    name: "Pawan Mantri",
    designation: "Member",
    image: require("../assets/members/Pawan Mantri.png"),
  },
  {
    name: "Mahendra Rathi",
    designation: "Member",
    image: require("../assets/members/Mahendra Rathi.png"),
  },
  {
    name: "Sushila Rathi",
    designation: "Member",
    image: require("../assets/members/Sushila Rathi.png"),
  },
  {
    name: "Om Prakash Bhootra",
    designation: "Member",
    image: require("../assets/members/Om Prakash Bhootra.png"),
  },
  {
    name: "Yogesh Soni",
    designation: "Member",
    image: require("../assets/members/Yogesh Soni.png"),
  },
  {
    name: "Pukhraj Manihar",
    designation: "Treasurer",
    image: require("../assets/members/Pukhraj Manihar.png"),
  },
  {
    name: "Kailash Somani",
    designation: "Member",
    image: require("../assets/members/Kailash Somani.png"),
  },
  {
    name: "Rameshwari Bhootra",
    designation: "Member",
    image: require("../assets/members/Rameshwari Bhootra.png"),
  },
  {
    name: "Shanti Lohiya",
    designation: "Member",
    image: require("../assets/members/Shanti Lohiya.png"),
  },
  {
    name: "Pushpa Bihani",
    designation: "Member",
    image: require("../assets/members/Pushpa Bihani.png"),
  },
  {
    name: "Govardhan Lakhotiya",
    designation: "Member",
    image: require("../assets/members/Govardhan Lakhotiya.png"),
  },
  {
    name: "Sudhir Rathi",
    designation: "Member",
    image: require("../assets/members/Sudhir Rathi.png"),
  },
  {
    name: "Moolchand Mundra",
    designation: "Member",
    image: require("../assets/members/Mulchand Mundra.png"),
  },
  {
    name: "Vikas Dhoot",
    designation: "Member",
    image: require("../assets/members/Vikas Dhoot.jpeg"),
  },
  {
    name: "Deepak Mutha",
    designation: "Member",
    image: require("../assets/members/Deepak Mutha.png"),
  },
  {
    name: "Vinit Bhandari",
    designation: "Member",
    image: require("../assets/members/Vinit Bhandari.png"),
  },
  {
    name: "Alka Johari",
    designation: "Member",
    image: require("../assets/members/Alka Johri.png"),
  },
  {
    name: "Vishnu Phophaliya",
    designation: "Member",
    image: require("../assets/members/Vishnu Phoophaliya.png"),
  },
];
